import { ONE_DAY_IN_MS } from 'constants/time';

export const EVENT_REASON_PROMPT_ENTITY_ID = '0';

/** 7 days */
export const EVENT_REASON_SNOOZE_DURATION_MS = 7 * ONE_DAY_IN_MS;

/** Also enforced in lib-entities event_reason_tagging.free_text and backend-api CreateEventReasonTaggingDto. */
export const EVENT_REASON_FREE_TEXT_MAX_LENGTH = 200;
